import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=194c8a28&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"
import style0 from "./Contact.vue?vue&type=style&index=0&id=194c8a28&prod&lang=css"
import style1 from "./Contact.vue?vue&type=style&index=1&id=194c8a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194c8a28",
  null
  
)

export default component.exports